<template>
  <BaseButton
    :size="size"
    :data-testid="dataTestId"
    class="tw:font-bold tw:border tw:border-red-700 tw:text-white tw:bg-red-700"
    v-bind="$attrs"
  >
    <slot />
  </BaseButton>
</template>

<script setup>
import BaseButton from './BaseButton.vue'
defineProps({
  size: {
    type: String,
    default: 'big',
  },
  dataTestId: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
@media (hover: hover) and (pointer: fine) {
  button:hover {
    background-color: var(--tw-color-red-800);
    border-color: var(--tw-color-red-800);
  }
}
button:disabled {
  background-color: var(--tw-color-red-200);
  border-color: var(--tw-color-red-200);
}
</style>
